export enum ERROR {
  AuthHeaderUndefinedError = 'AuthHeaderUndefined',
  ProjectIdMissingError = 'ProjectIdMissing',
  OtherError = 'Other',
}
